var gsChatModule = (function () {

    /**
     * =====================================================
     * WS Connection Low Level Module
     * =====================================================
     */

    var configGlobal = {
        websocketURL: undefined,
        websocketSecure: false,
        backendURL: undefined,
        token: undefined,
        uid: undefined,
        preventAutojoin: false,
        checkForjQuery: true, //skip jQuery check, set to false for custom integration
        preventSGXSessionStart: false, //skip SGX session start management, sends events instead for custom integrations (e.g. React)
        inDiv: false,
    };
    var WsConnection;
    var identificationToken;
    var uid;
    var chatBot;

    /**
     * This class is a message sent from the server to the client.
     */
    class Response {

        static get AUTH_RESPONSE_ACTION() {
            return 'auth_response';
        }

        static get SUBSCRIBE_RESPONSE() {
            return 'subscribe_response';
        }

        static get UNSUBSCRIBE_RESPONSE() {
            return 'unsubscribe_response';
        }

        static get MESSAGE_CHAN_OUT_RESPONSE() {
            return 'message_chan_out';
        }

        static get MESSAGE_CHAN_BOT_RESPONSE() {
            return 'message_chan_bot';
        }

        static get QUICKMATCH_REQUEST_ACK_RESPONSE() {
            return 'quick_match_request_ack';
        }

        static get QUICKMATCH_DESIST_ACK_RESPONSE() {
            return 'quick_match_desist_ack';
        }

        static get QUICKMATCH_OWNER_START_REQUEST_RESPONSE() {
            return 'quick_match_owner_start_request';
        }

        static get QUICKMATCH_GUESTS_JOIN_REQUEST_RESPONSE() {
            return 'quick_match_guest_join_request';
        }

        static get ADMIN_GET_LOBBIES_LIST_RESPONSE() {
            return 'admin_get_lobbies_list_response';
        }

        constructor(action) {
            this.action = action;
        }
    }

    /**
     * This class is a message sent from the server to all clients.
     */
    class Notification extends Response {

        static get SUBSCRIBE_NOTIFICATION() {
            return 'subscribe_notification';
        }

        static get UNSUBSCRIBE_NOTIFICATION() {
            return 'unsubscribe_notification';
        }

        static get QUICKMATCH_REQUEST_NOTIFICATION() {
            return 'quick_match_request_notification';
        }

        static get QUICKMATCH_LOBBY_CLOSE_NOTIFICATION() {
            return 'quick_match_lobby_close_notification';
        }

        static get ADMIN_PLAYER_UPDATE_NOTIFICATION() {
            return 'admin_player_update_notification';
        }

        static get QUICKMATCH_OWNER_START_REQUEST_ERROR_NOTIFICATION() {
            return 'quick_match_owner_start_request_error_notification';
        }

        static get ADMIN_SERVER_UPDATE_NOTIFICATION() {
            return 'admin_server_update_notification';
        }

        constructor(action) {
            super(action);
        }
    }

    /**
     * This class represents the subscribe notification sent by the server to clients.
     */
    class SubscribeNotification extends Notification {

        constructor(data){
            if (data.action !== Notification.SUBSCRIBE_NOTIFICATION){
                throw new Error('Action mismatch, expected "subscribe_notification" got "' + data.action +'".');
            } else {
                super(Notification.SUBSCRIBE_NOTIFICATION);
            }
            this.channel = data.channel;
            this.targetProfile = data.targetUser;
            this.time = data.time;
        }
    }

    /**
     * This class represents the unsubscribe notification sent by the server to clients.
     */
    class UnsubscribeNotification extends Notification {

        constructor(data) {
            if (data.action !== Notification.UNSUBSCRIBE_NOTIFICATION){
                throw new Error('Action mismatch, expected "unsubscribe_notification" got "' + data.action +'".');
            } else {
                super(Notification.UNSUBSCRIBE_NOTIFICATION);
            }
            this.channel = data.channel;
            this.targetProfile = data.targetUser;
            this.time = data.time
        }
    }

    /**
     * This class represents the quick match request notification sent by the server to lobby clients.
     */
    class QuickMatchRequestNotification extends Notification {
        constructor (data) {
            if (data.action !== Notification.QUICKMATCH_REQUEST_NOTIFICATION){
                throw new Error('Action mismatch, expected "quick_match_request_notification" got "' + data.action +'".');
            } else {
                super(Notification.QUICKMATCH_REQUEST_NOTIFICATION);
            }
            this.lobby = data.lobby;
        }
    }

    /**
     * This class reprensents the quick match lobby close notification sent by the server to lobby clients.
     */
    class QuickMatchLobbyCloseNotification extends Notification {
        constructor (data) {
            if (data.action !== Notification.QUICKMATCH_LOBBY_CLOSE_NOTIFICATION){
                throw new Error('Action mismatch, expected "quick_match_lobby_close_notification" got "' + data.action +'".');
            } else {
                super(Notification.QUICKMATCH_LOBBY_CLOSE_NOTIFICATION);
            }
            this.lobbyId = data.lobbyId;
            this.reason = data.reason;
        }
    }

    /**
     * This class represents the admin player update notification sent by the server to clients.
     */
    class AdminPlayerUpdateNotification extends Notification {
        constructor (data) {
            if (data.action !== Notification.ADMIN_PLAYER_UPDATE_NOTIFICATION){
                throw new Error('Action mismatch, expected "quick_match_request_notification" got "' + data.action +'".');
            } else {
                super(Notification.ADMIN_PLAYER_UPDATE_NOTIFICATION);
            }
            this.player = data.player;
        }
    }

    class QuickMatchOwnerStartRequestErrorNotification extends Notification {
        constructor (data) {
            if (data.action !== Notification.QUICKMATCH_OWNER_START_REQUEST_ERROR_NOTIFICATION) {
                throw new Error('Action mismatch, expected "quick_match_owner_start_request_error_notification" got "' + data.action +'".');
            } else {
                super(Notification.QUICKMATCH_OWNER_START_REQUEST_ERROR_NOTIFICATION);
            }
            this.reason = data.reason;
        }
    }

    /**
     * This class represents the admin server update notification send to all clients.
     */
    class AdminServerUpdateNotification extends Notification {
        constructor (data) {
            if (data.action !== Notification.ADMIN_SERVER_UPDATE_NOTIFICATION) {
                throw new Error('Action mismatch, expected "admin_server_update_notification" got "' + data.action + '".');
            } else {
                super(Notification.ADMIN_SERVER_UPDATE_NOTIFICATION);
            }

            this.gameList = data.gameList;
            this.chanList = data.chanList;
        }
    }

    /**
     * This class is a message sent from the client to the server.
     */
    class Action {

        static get AUTH_ACTION() {
            return 'auth';
        }

        static get SUBSCRIBE_ACTION() {
            return 'subscribe';
        }

        static get UNSUBSCRIBE_ACTION() {
            return 'unsubscribe';
        }

        static get MESSAGE_CHAN_IN_ACTION() {
            return 'message_chan_in';
        }

        static get QUICKMATCH_REQUEST_ACTION() {
            return 'quick_match_request';
        }

        static get QUICKMATCH_OWNER_FORCE_START_REQUEST(){
            return 'quick_match_owner_force_start_request';
        }

        static get QUICKMATCH_DESIST_ACTION() {
            return 'quick_match_desist';
        }

        static get QUICKMATCH_OWNER_START_REQUEST_ERROR_ACTION() {
            return 'quick_match_owner_start_request_error';
        }

        static get QUICKMATCH_OWNER_START_REQUEST_ACK_ACTION() {
            return 'quick_match_owner_start_request_ack';
        }

        static get QUICKMATCH_GUESTS_JOIN_REQUEST_ACK_ACTION() {
            return 'quick_match_guest_join_request_ack';
        }

        static get ADMIN_PLAYER_UPDATE_REQUEST_ACTION() {
            return 'admin_player_update_request';
        }

        static get ADMIN_GET_LOBBIES_LIST_REQUEST_ACTION() {
            return 'admin_get_lobbies_list_request';
        }

        static get QUICKMATCH_GUESTS_JOIN_REQUEST_ERROR_ACTION() {
            return 'quick_match_guest_join_request_error';
        }

        constructor(action) {
            this.action = action;
        }

        sendable() {
            return {
                action: this.action
            }
        }

        getAction() {
            return this.action;
        }
    }

    /**
     * This class represents an auth action sent to the server.
     */
    class AuthAction extends Action {
        constructor (token, uid) {
            super(Action.AUTH_ACTION);
            this.token = token;
            this.uid = uid;
        }

        sendable() {
            return {
                action: super.getAction(),
                token: this.token,
                uid: this.uid
            }
        }
    }

    /**
     * This class represents the subscribe message sent to the server.
     */
    class SubscribeAction extends Action{

        constructor (channelSlug) {
            super(Action.SUBSCRIBE_ACTION);
            this.channelSlug = channelSlug;
        }

        sendable() {
            return {
                action: super.getAction(),
                channel: this.channelSlug
            }
        }
    }

    /**
     * This class represents the unsubscribe message sent to the server.
     */
    class UnsubscribeAction extends Action {

        constructor (channelSlug) {
            super(Action.UNSUBSCRIBE_ACTION);
            this.channelSlug = channelSlug;
        }

        sendable() {
            return {
                action: super.getAction(),
                channel: this.channelSlug
            }
        }
    }

    /**
     * This class represents a message to send to the server.
     */
    class MessageChanInAction extends Action {
        constructor (channel, message, origin=null) {
            super(Action.MESSAGE_CHAN_IN_ACTION);
            this.channel = channel;
            this.message = message;
            this.origin = origin;
        }

        sendable() {
            return {
                action: super.getAction(),
                channel: this.channel.slug,
                message: this.message,
                origin: this.origin
            }
        }
    }

    /**
     * This class represents a quick match request sent to the server.
     */
    class QuickMatchRequestAction extends Action {
        constructor (gameSlug, nbLocalPlayers) {
            super(Action.QUICKMATCH_REQUEST_ACTION);
            this.gameSlug = gameSlug;
            this.nbLocalPlayers = nbLocalPlayers;
        }

        sendable() {
            return {
                action: super.getAction(),
                gameSlug: this.gameSlug,
                nbLocalPlayers: this.nbLocalPlayers
            }
        }
    }

    /**
     * This class represents a quick match force start request sent to the server.
     */
    class QuickMatchOwnerForceStartRequest extends Action {
        constructor (lobbyId) {
            super(Action.QUICKMATCH_OWNER_FORCE_START_REQUEST);
            this.lobbyId = lobbyId;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId,
            }
        }
    }

    /**
     * This class represents a quick match desist action sent to the server.
     */
    class QuickMatchDesistAction extends Action {
        constructor (lobbyId) {
            super(Action.QUICKMATCH_DESIST_ACTION);
            this.lobbyId = lobbyId;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId
            }
        }
    }

    /**
     * This class represents a quick match owner start request failure to send to the server.
     */
    class QuickMatchOwnerStartRequestErrorAction extends Action {
        constructor (lobbyId, reason) {
            super(Action.QUICKMATCH_OWNER_START_REQUEST_ERROR_ACTION);
            this.lobbyId = lobbyId;
            this.reason = reason;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId,
                reason: this.reason
            }
        }
    }

    /**
     * This class represents a quick match guests join request failure to send to the server.
     */
    class QuickMatchGuestsJoinRequestErrorAction extends Action {
        constructor (lobbyId, reason) {
            super(Action.QUICKMATCH_GUESTS_JOIN_REQUEST_ERROR_ACTION);
            this.lobbyId = lobbyId;
            this.reason = reason;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId,
                reason: this.reason
            }
        }
    }

    class QuickMatchOwnerStartRequestAckAction extends Action {
        constructor (lobbyId, masterSessionKey) {
            super(Action.QUICKMATCH_OWNER_START_REQUEST_ACK_ACTION);
            this.lobbyId = lobbyId;
            this.masterSessionKey = masterSessionKey;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId,
                masterSessionKey: this.masterSessionKey
            }
        }
    }

    class QuickMatchGuestsJoinRequestAckAction extends Action {
        constructor (lobbyId, sessionKey) {
            super(Action.QUICKMATCH_GUESTS_JOIN_REQUEST_ACK_ACTION);
            this.lobbyId = lobbyId;
            this.sessionKey = sessionKey;
        }

        sendable() {
            return {
                action: super.getAction(),
                lobbyId: this.lobbyId,
                sessionKey: this.sessionKey
            }
        }
    }

    /**
     * This class represents the player update request sent by an admin to
     * the server.
     */
    class AdminPlayerUpdateRequestAction extends Action {
        constructor (player) {
            super(Action.ADMIN_PLAYER_UPDATE_REQUEST_ACTION);
            this.player = player;
        }

        sendable() {
            return {
                action: super.getAction(),
                player: this.player
            }
        }
    }

    /**
     * This class represents the admin request to get lobbies sent to the server.
     */
    class AdminGetLobbiesListRequestAction extends Action {
        constructor () {
            super(Action.ADMIN_GET_LOBBIES_LIST_REQUEST_ACTION);
        }

        sendable() {
            super.sendable();
        }
    }

    class ErrorResponse extends Response {

        static get AUTH_ERROR_RESPONSE() {
            return 'auth_error';
        }

        static get SUBSCRIBE_ERROR_RESPONSE() {
            return 'subscribe_error';
        }

        static get UNSUBSCRIBE_ERROR_RESPONSE() {
            return 'unsubscribe_error';
        }

        static get MESSAGE_CHAN_IN_ERROR_RESPONSE() {
            return 'message_chan_in_error';
        }

        static get QUICKMATCH_REQUEST_ERROR_RESPONSE() {
            return 'quick_match_request_error';
        }

        static get QUICKMATCH_DESIST_ERROR_RESPONSE() {
            return 'quick_match_desist_error';
        }

        static get QUICKMATCH_OWNER_FORCE_START_ERROR() {
            return 'quick_match_owner_force_start_error';
        }

        constructor(action, reason) {
            super(action);
            this.reason = reason;
        }
    }

    /**
     * Response in case of successful authentication.
     */
    class AuthResponse extends Response {

        constructor(data) {
            if (data.action !== Response.AUTH_RESPONSE_ACTION){
                throw new Error('Action mismatch, expected "auth_response" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.autoJoin = data.autoJoin;
            this.playerInfos = data.playerInfos;
            this.botInfos = data.botInfos;
            this.chanList = data.chanList;
            this.quickMatchLobby = data.quickMatchLobby;
            this.gameList = data.gameList;
            this.profile = data.profile;
        }
    }

    /**
     * Response in case of successful subscription to a channel.
     */
    class SubscribeResponse extends Response {

        constructor (data) {
            if (data.action !== Response.SUBSCRIBE_RESPONSE){
                throw new Error('Action mismatch, expected "subscribe_response" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.channel = data.channel;
            this.profiles = data.users;
        }
    }

    /**
     * Response in case of successful unsubscription to a channel.
     */
    class UnsubscribeResponse extends Response {

        constructor (data) {
            if (data.action !== Response.UNSUBSCRIBE_RESPONSE){
                throw new Error('Action mismatch, expected "unsubscribe_response" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.channel = data.channel;
        }
    }

    /**
     * Response when a message is received from the server.
     */
    class MessageChanOutResponse extends Response {
        constructor (data) {
            if (data.action !== Response.MESSAGE_CHAN_OUT_RESPONSE){
                throw new Error('Action mismatch, expected "message_chan_out" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.uid = data.user;
            this.channel = data.channel;
            this.message = data.message;
            this.time = data.time
        }
    }

    /**
     * Response when a bot message is received from the server.
     */
    class MessageChanBotResponse extends Response {
        constructor (data) {
            if (data.action !== Response.MESSAGE_CHAN_BOT_RESPONSE){
                throw new Error('Action mismatch, expected "message_chan_bot" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.channel = data.channel;
            this.message = data.message;
        }
    }

    /**
     * Acknowledgement response when the quick match request is successful.
     */
    class QuickMatchRequestAckResponse extends Response {
        constructor (data) {
            if (data.action !== Response.QUICKMATCH_REQUEST_ACK_RESPONSE){
                throw new Error('Action mismatch, expected "quick_match_request_ack" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.lobby = data.lobby;
        }
    }

    /**
     * Acknowledgement response when the quick match desist is successful.
     */
    class QuickMatchDesistAckResponse extends Response {
        constructor (data) {
            if (data.action !== Response.QUICKMATCH_DESIST_ACK_RESPONSE){
                throw new Error('Action mismatch, expected "quick_match_desist_ack" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.lobbyId = data.lobbyId;
        }
    }

    /**
     * Response for quick match owner start request.
     */
    class QuickMatchOwnerStartRequestResponse extends Response {
        constructor (data) {
            if (data.action !== Response.QUICKMATCH_OWNER_START_REQUEST_RESPONSE){
                throw new Error('Action mismatch, expected "quick_match_owner_start" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.lobby = data.lobby;
        }
    }

    /**
     * Response for quick match guests join request.
     */
    class QuickMatchGuestsJoinRequestResponse extends Response {
        constructor (data) {
            if (data.action !== Response.QUICKMATCH_GUESTS_JOIN_REQUEST_RESPONSE) {
                throw new Error('Action mismatch, expected "quick_match_guest_join_request" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.lobby = data.lobby;
            this.masterSessionKey = data.masterSessionKey;
        }
    }

    /**
     * Response with the lobbies list for admin.
     */
    class AdminGetLobbiesListResponse extends Response {
        constructor (data) {
            if (data.action !== Response.ADMIN_GET_LOBBIES_LIST_RESPONSE){
                throw new Error('Action mismatch, expected "admin_get_lobbies_list_response" got "' + data.action +'".');
            } else {
                super(data.action);
            }

            this.quickMatchLobbies = data.quickMatchLobbies;
            this.quickMatchLobbyByUser = data.quickMatchLobbyByUser;
        }
    }

    /**
     * Response in case of authentication failure.
     */
    class AuthErrorResponse extends ErrorResponse {
        constructor (data) {
            if (data.action !== ErrorResponse.AUTH_ERROR_RESPONSE){
                throw new Error('Action mismatch, expected "auth_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.AUTH_ERROR_RESPONSE, data.reason);
            }
        }
    }

    /**
     * Response in case of subscription failure.
     */
    class SubscribeErrorResponse extends ErrorResponse {
        constructor (data) {
            if (data.action !== ErrorResponse.SUBSCRIBE_ERROR_RESPONSE) {
                throw new Error('Action mismatch, expected "subscribe_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.SUBSCRIBE_ERROR_RESPONSE, data.reason)
            }
        }
    }

    /**
     * Response in case of unsubscription failure.
     */
    class UnsubscribeErrorResponse extends ErrorResponse {
        constructor (data){
            if (data.action !== ErrorResponse.UNSUBSCRIBE_ERROR_RESPONSE){
                throw new Error('Action mismatch, expected "unsubscribe_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.UNSUBSCRIBE_ERROR_RESPONSE, data.reason);
            }
        }
    }

    /**
     * Response in case of message sending failure.
     */
    class MessageChanInErrorResponse extends ErrorResponse {
        constructor (data){
            if (data.action !== ErrorResponse.MESSAGE_CHAN_IN_ERROR_RESPONSE){
                throw new Error('Action mismatch, expected "message_chan_in_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.MESSAGE_CHAN_IN_ERROR_RESPONSE, data.reason);
            }
        }
    }

    /**
     * Response in case of quick match request failure.
     */
    class QuickMatchRequestErrorReponse extends ErrorResponse {
        constructor (data) {
            if (data.action !== ErrorResponse.QUICKMATCH_REQUEST_ERROR_RESPONSE){
                throw new Error('Action mismatch, expected "message_chan_in_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.QUICKMATCH_REQUEST_ERROR_RESPONSE, data.reason);
            }
        }
    }

    /**
     * Response in case of quick match desist failure.
     */
    class QuickMatchDesistErrorResponse extends ErrorResponse {
        constructor (data) {
            if (data.action !== ErrorResponse.QUICKMATCH_DESIST_ERROR_RESPONSE){
                throw new Error('Action mismatch, expected "message_chan_in_error" got "' + data.action + '".');
            } else {
                super(ErrorResponse.QUICKMATCH_DESIST_ERROR_RESPONSE, data.reason);
                this.lobbyId = data.lobbyId;
            }
        }
    }

    class QuickMatchOwnerForceStartErrorResponse extends ErrorResponse {
        constructor(data) {
            if(data.action !== ErrorResponse.QUICKMATCH_OWNER_FORCE_START_ERROR){
                throw new Error('Action mismatch, expected "quick_match_owner_force_start_error" got "\' + data.action + \'".\'')
            } else {
                super(ErrorResponse.QUICKMATCH_OWNER_FORCE_START_ERROR, data.reason);
                this.lobbyId = data.lobbyId;
            }
        }
    }

    /**
     * Inits the chat module.
     * @throws WsConnection.SECURITY_ERR
     * @param config object
     */
    function boot(config) {
        if (config === null){
            throw new Error('Config is needed!');
        }

        //merging default config with given config
        configGlobal = Object.assign(configGlobal, config);
        console.debug('Working with config:');
        console.debug(configGlobal);

        if (config.checkForjQuery){
            //checking jQuery existence
            if (!window.jQuery){
                console.error('Please ensure jQuery is loaded before booting up GS Chat!');
                return;
            }
        }

        if (config.websocketURL === undefined) {
            throw new Error('You must provide a WS URL.');
        }

        try {
            var url;
            if (config.websocketSecure) {
                url = 'wss://' + config.websocketURL;
            } else {
                url = 'ws://' + config.websocketURL;
            }

            WsConnection = new WebSocket(url);
            WsConnection.onopen = wsOnOpen;
            WsConnection.onclose = wsOnClose;
            WsConnection.onmessage = wsOnMessage;
            WsConnection.onerror = wsOnError;

            //checking token presence
            if (config.token === undefined) {
                throw new Error('You must provide an identification token.');
            }

            //checking for uid presence
            if (config.uid === undefined) {
                throw new Error('You must provide a profile UID.');
            }
        } catch (e) {
            console.log(e);
        }

        identificationToken = config.token;
        uid = config.uid;

        console.debug('GS Chat Connected! ' + "\ud83c\udfae");
    }

    /**
     * Closes the chat module.
     */
    function close() {
        WsConnection.close();
    }

    /**
     * Event listener triggered when the WS connection is opened.
     * @param data Object
     */
    function wsOnOpen(data) {
        // authenticating user on WS opening
        var authAction = new AuthAction(identificationToken, uid);
        wsSend(authAction.sendable());

        var event = new CustomEvent('gs-open', {detail: {data: data}});
        document.dispatchEvent(event);
    }

    /**
     * Event listener triggered when the WS connection is closing.
     * @param data
     */
    function wsOnClose(data) {
        console.debug('GS Chat connection closing, bye!');

        var event = new CustomEvent('gs-close', {detail: {data}});
        document.dispatchEvent(event);
    }

    /**
     * Event listener triggered on new message on the WS connection.
     * @param message
     */
    function wsOnMessage(message) {
        try {
            var data = JSON.parse(message.data);

            //checking for action field
            if (!('action' in data)){
                throw new Error('Message payload must provide an "action".');
            }

            switch (data.action) {
                //when an auth response is received from the WS
                case Response.AUTH_RESPONSE_ACTION:
                    //creating current user from auth response
                    var authResponse = new AuthResponse(data);
                    var profile = ChatModule.createProfileFromAuthResponse(authResponse);
                    ChatModule.setCurrentProfile(profile);

                    //creating lists
                    ChatModule.createGameListFromAuthResponse(authResponse);
                    ChatModule.createChannelListFromAuthResponse(authResponse);

                    //creating bot from auth response
                    chatBot = ChatModule.createProfile(authResponse.botInfos.username,
                        authResponse.botInfos.nickname,
                        authResponse.botInfos.avatar);

                    //checking if
                    if (configGlobal.preventAutojoin === false){
                        //autojoining channel if defined
                        if (authResponse.autoJoin !== undefined){
                            authResponse.autoJoin.forEach(function (channel) {
                                var autoJoinAction = new SubscribeAction(channel);
                                wsSend(autoJoinAction.sendable());
                                console.debug('Autojoining #' + channel + ' channel.');
                            });
                        }
                    }

                    //sending auth event
                    var event = new CustomEvent('gs-auth', {detail: {
                            user: profile,
                            channelList: ChatModule.getChannelList(),
                            bot: authResponse.botInfos
                    }});
                    document.dispatchEvent(event);

                    //checking if player is in a lobby
                    if (authResponse.quickMatchLobby !== null){
                        console.debug(user.nickname + ' is in a lobby for game ' + authResponse.quickMatchLobby.game.name + '.');

                        var lobby = ChatModule.createLobby(authResponse.quickMatchLobby);

                        //creating lobby in memory
                        ChatModule.setCurrentQuickMatchLobby(lobby);

                        //sending event to the view
                        var event = new CustomEvent('gs-quick-match-request-ack', {detail: {
                                lobby: lobby
                        }});
                        document.dispatchEvent(event);
                    }
                    break;

                //when an auth response error is received from the WS
                case ErrorResponse.AUTH_ERROR_RESPONSE:
                    var authErrorReponse = new AuthErrorResponse(data);

                    //sending auth error event
                    var event = new CustomEvent('gs-auth-error', {detail: {
                            error: authErrorReponse.reason,
                            fatal: true
                    }});
                    document.dispatchEvent(event);

                    console.error('Auth error: ' + authErrorReponse.reason);
                    break;

                //when a subscribe response is received from the WS
                case Response.SUBSCRIBE_RESPONSE:
                    var subscribeResponse = new SubscribeResponse(data);
                    var channel = ChatModule.getChannelBySlug(subscribeResponse.channel);

                    //parsing users
                    subscribeResponse.profiles.forEach(function (profile) {
                        channel.addProfile(ChatModule.createProfile(profile.uid, profile.nickname, profile.avatar));
                    });

                    //subscribing user to channel
                    ChatModule.setCurrentChannel(channel);
                    ChatModule.subscribedChannels.push(channel);

                    //sending subscription event to the view
                    var event = new CustomEvent('gs-subscribe', {detail: {
                            channel: channel,
                            profiles: channel.getProfiles()
                    }});
                    document.dispatchEvent(event);

                    console.debug('Successfully subscribed to #' + channel.name + '. There are ' + channel.profiles.length + ' users in the channel.');
                    break;

                //when a subscribe notification is received from the WS
                case Notification.SUBSCRIBE_NOTIFICATION:
                    var subscribeNotification = new SubscribeNotification(data);
                    var channel = ChatModule.getChannelBySlug(subscribeNotification.channel);
                    var targetProfile = ChatModule.createProfile(subscribeNotification.targetProfile.uid,
                        subscribeNotification.targetProfile.nickname,
                        subscribeNotification.targetProfile.avatar);

                    channel.addProfile(targetProfile);

                    //sending subscribtion event
                    var event = new CustomEvent('gs-join', {detail: {
                            channel: channel,
                            bot: chatBot,
                            time: subscribeNotification.time,
                            message: targetProfile.nickname + ' joined #' + channel.name + '.',
                            profile: targetProfile
                    }});
                    document.dispatchEvent(event);

                    //sending message to channel
                    //ChatModule.sendBotMessageToChannel(channel, targetUser.nickname + ' has joined #' + channel.name);

                    console.debug(targetProfile.nickname + ' joined #' + channel.name + '.');
                    break;

                //when a subscribe error response is received from the WS
                case ErrorResponse.SUBSCRIBE_ERROR_RESPONSE:
                    var subscribeErrorResponse = new SubscribeErrorResponse(data);
                    console.error('Subscription error: ' + subscribeErrorResponse.reason);
                    break;

                //when an unsubscribe notification is received from the WS
                case Notification.UNSUBSCRIBE_NOTIFICATION:
                    var unsubscribeNotification = new UnsubscribeNotification(data);
                    var profile = unsubscribeNotification.targetProfile;
                    var channel = ChatModule.getChannelBySlug(unsubscribeNotification.channel);

                    channel.removeProfile(profile);

                    //sending unsubscription event
                    var event = new CustomEvent('gs-leave', {detail: {
                            channel: channel,
                            bot: chatBot,
                            time: unsubscribeNotification,
                            message: profile.nickname + ' left #' + channel.name + '.'
                    }});
                    document.dispatchEvent(event);

                    console.debug(profile.nickname + ' left #' + channel.name + '.');
                    break;

                //when an unsubscribe response is received from the WS
                case Response.UNSUBSCRIBE_RESPONSE:
                    var unsubscribeResponse = new UnsubscribeResponse(data);
                    var channel = ChatModule.getChannelBySlug(unsubscribeResponse.channel);

                    //removing current user from the channel
                    channel.removeProfile(ChatModule.getCurrentProfile());

                    //sending event to the view
                    var event = new CustomEvent('gs-unsubscribe', {detail: {
                            channel: channel
                    }});
                    document.dispatchEvent(event);

                    console.debug('Successfully unsubscribed to #' + channel.name + '.');
                    break;

                //when an unsubscribe error response is received from the WS
                case ErrorResponse.UNSUBSCRIBE_ERROR_RESPONSE:
                    var unsubscribeErrorResponse = new UnsubscribeErrorResponse(data);

                    //sending event to the view
                    var event = new CustomEvent('gs-unsubscribe-error', {detail: {
                            error: unsubscribeErrorResponse.reason,
                            fatal: false
                    }});
                    document.dispatchEvent(event);

                    console.error('Unsubscription error: ' + unsubscribeErrorResponse.reason);
                    break;

                //when a message is received from the WS
                case Response.MESSAGE_CHAN_OUT_RESPONSE:
                    var messageChanOutResponse = new MessageChanOutResponse(data);
                    var channel = ChatModule.getChannelBySlug(messageChanOutResponse.channel);
                    var profile = channel.getProfileByUID(messageChanOutResponse.uid);

                    //sending new message event
                    var event = new CustomEvent('gs-message', {detail: {
                            message: messageChanOutResponse.message,
                            profile: profile,
                            channel: channel,
                            time: messageChanOutResponse.time
                    }});
                    document.dispatchEvent(event);

                    console.debug('Message received from ' + profile.nickname + ' in channel #' + channel.name + ': ' + messageChanOutResponse.message);
                    break;

                //when a message from a bot is received from the WS
                case Response.MESSAGE_CHAN_BOT_RESPONSE:
                    var messageChanBotResponse = new MessageChanBotResponse(data);

                    console.debug('Message received from bot: ' + messageChanBotResponse.message);
                    break;

                //when a quick match acknowledgement response is received from the WS
                case Response.QUICKMATCH_REQUEST_ACK_RESPONSE:
                    var quickmatchRequestAckResponse = new QuickMatchRequestAckResponse(data);

                    var lobby = ChatModule.createLobby(quickmatchRequestAckResponse.lobby);
                    ChatModule.setCurrentQuickMatchLobby(lobby);

                    //sending quick match request ack event
                    var event = new CustomEvent('gs-quick-match-request-ack', {detail: {
                            lobby: lobby
                    }});
                    document.dispatchEvent(event);

                    console.debug('Quick match created successfully for game ' + lobby.game.name);
                    break;

                //when a quick match notification is received from the WS
                case Notification.QUICKMATCH_REQUEST_NOTIFICATION:
                    var quickMatchRequestNotification = new QuickMatchRequestNotification(data);

                    var lobby = ChatModule.createLobby(quickMatchRequestNotification.lobby);

                    //sending quick match request notification event to the view
                    var event = new CustomEvent('gs-quick-match-request-notification', {detail: {
                            lobby: lobby
                    }});
                    document.dispatchEvent(event);
                    break;

                //when a quick match request error is received from the WS
                case ErrorResponse.QUICKMATCH_REQUEST_ERROR_RESPONSE:
                    var quickMatchRequestErrorResponse = new QuickMatchRequestErrorReponse(data);

                    //sending quick match request error to the view
                    var event = new CustomEvent('gs-quick-match-error', {detail: {
                            error: quickMatchRequestErrorResponse.reason
                    }});
                    document.dispatchEvent(event);
                    break;

                //when the server confirms the desistment of the user for a lobby
                case Response.QUICKMATCH_DESIST_ACK_RESPONSE:
                    var quickMatchDesistAckResponse = new QuickMatchDesistAckResponse(data);

                    ChatModule.setCurrentQuickMatchLobby(null);

                    //sending quick match desist event to the view
                    var event = new CustomEvent('gs-quick-match-desist');
                    document.dispatchEvent(event);

                    console.debug(ChatModule.getCurrentProfile().nickname + ' left the lobby with ID ' + quickMatchDesistAckResponse.lobbyId);
                    break;

                //when the server could not validate the user desistment for a lobby
                case ErrorResponse.QUICKMATCH_DESIST_ERROR_RESPONSE:
                    var quickMatchDesistErrorReponse = new QuickMatchDesistErrorResponse(data);

                    //sending quick match desist error event to the view
                    var event = new CustomEvent('gs-quick-match-error', {detail: {
                            error: quickMatchDesistErrorReponse.reason
                    }});
                    document.dispatchEvent(event);

                    console.error('Quickmatch desistment error: ' + data.reason);
                    break;

                case ErrorResponse.QUICKMATCH_OWNER_FORCE_START_ERROR:
                    var quickMatchOwnerForceStartError = new QuickMatchOwnerForceStartErrorResponse(data);

                    var event = new CustomEvent('gs-quick-match-owner-force-start-error', {detail: {
                            error: quickMatchOwnerForceStartError.reason
                        }})
                    document.dispatchEvent(event);

                    console.error('Quickmatch owner force start error: ' + data.reason);
                    break;

                //when the server send a quick match owner start request
                case Response.QUICKMATCH_OWNER_START_REQUEST_RESPONSE:
                    var quickMatchOwnerStartRequestResponse = new QuickMatchOwnerStartRequestResponse(data);
                    var lobby = quickMatchOwnerStartRequestResponse.lobby;

                    if (configGlobal.preventSGXSessionStart === true) {
                        //simply send an event
                        var event = new CustomEvent('gs-quick-match-owner-start-request', {detail: {
                            lobby: lobby
                        }});
                        document.dispatchEvent(event);
                    } else {
                        //start SGX session
                        SessionRunnerModule.init('quickmatchowner', null, lobby);
                    }

                    console.debug('Quick match asked for start for lobby with ID: '+ lobby.id);
                    break;

                case Notification.QUICKMATCH_OWNER_START_REQUEST_ERROR_NOTIFICATION:
                    var quickMatchOwnerStartRequestErrorNotification = new QuickMatchOwnerStartRequestErrorNotification(data);

                    var event = new CustomEvent('gs-multiplayer-error', {detail: {
                        error: quickMatchOwnerStartRequestErrorNotification.reason
                    }});
                    document.dispatchEvent(event);

                    console.error('Error from owner start session: ' + quickMatchOwnerStartRequestErrorNotification.reason);

                    break;

                //when the server sends a quick match guests join request
                case Response.QUICKMATCH_GUESTS_JOIN_REQUEST_RESPONSE:
                    var quickMatchGuestsJoinRequestResponse = new QuickMatchGuestsJoinRequestResponse(data);
                    var lobby = quickMatchGuestsJoinRequestResponse.lobby;
                    lobby.masterSessionKey = quickMatchGuestsJoinRequestResponse.masterSessionKey;

                    if (configGlobal.preventSGXSessionStart === true) {
                        //simply send an event
                        var event = new CustomEvent('gs-quick-match-guests-join-request', {detail: {
                            lobby: lobby
                        }});
                        document.dispatchEvent(event);
                    } else {
                        SessionRunnerModule.init('quickmatchguest', null, lobby);
                    }
                    break;

                //when the server tells the players that the session could not be started and the lobby should be closed
                case Notification.QUICKMATCH_LOBBY_CLOSE_NOTIFICATION:
                    var quickMatchLobbyCloseNotification = new QuickMatchLobbyCloseNotification(data);

                    //removing user from lobby
                    ChatModule.setCurrentQuickMatchLobby(null);

                    //sending lobby close event to the view
                    var event = new CustomEvent('gs-lobby-close', {detail: {
                            lobbyId: quickMatchLobbyCloseNotification.lobbyId,
                            reason: quickMatchLobbyCloseNotification.reason
                    }});
                    document.dispatchEvent(event);

                    //sending error event to the view
                    var event = new CustomEvent('gs-error', {detail: {
                            error: quickMatchLobbyCloseNotification.reason
                    }});
                    document.dispatchEvent(event);

                    console.error('An error occurred while starting a session for lobby with ID: ' + quickMatchLobbyCloseNotification.lobbyId + '. ' + quickMatchLobbyCloseNotification.reason);
                    break;

                //when a message could not be sent to the server
                case ErrorResponse.MESSAGE_CHAN_IN_ERROR_RESPONSE:
                    var messageChanInErrorResponse = new MessageChanInErrorResponse(data);
                    console.error('Message error: ' + messageChanInErrorResponse.reason);
                    break;

                //when a player update notification is received from the WS
                case Notification.ADMIN_PLAYER_UPDATE_NOTIFICATION:
                    var adminPlayerUpdateNotification = new AdminPlayerUpdateNotification(data);
                    console.debug('Player update notification received from admin.');
                    break;

                //when a lobbies list response is reived from the WS
                case Response.ADMIN_GET_LOBBIES_LIST_RESPONSE:
                    var adminGetLobbiesListResponse = new AdminGetLobbiesListResponse(data);
                    console.debug('Lobbies list received: ' + adminGetLobbiesListResponse.quickMatchLobbies.length);
                    break;

                //when a server update notification update is received
                case Notification.ADMIN_SERVER_UPDATE_NOTIFICATION:
                    document.location.reload();
                    break;

                case 'error':
                    console.error(data.reason);

                    //sending event to the view
                    var event = new CustomEvent('gs-error', {detail: {
                            error: data.reason
                    }});
                    document.dispatchEvent(event);
                    break;

                //the WS has received an unknown action
                default:
                    throw new Error('Unrecognized action in message.');
            }
        } catch (e) {
            console.error(e);

            //sending error event
            var event = new CustomEvent('gs-error', {detail: {
                    error: e,
                    fatal: true
                }});
            document.dispatchEvent(event);
        }
    }

    /**
     * Event listener triggered when the WS connection is in error.
     * @param data Object
     */
    function wsOnError(data) {
        var event = new CustomEvent('gs-error', {detail: {
            error: 'An error while communicating with the server occurred.'
        }});
        document.dispatchEvent(event);

        console.error('WS Error: a connection error occurred.');
    }

    /**
     * This method sends a payload throught the WS connection.
     * @param data Object
     */
    function wsSend(data) {
        try {
            WsConnection.send(JSON.stringify(data));
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * Returns the current status of the WS chat connection
     * @returns {WsConnection.CONNECTING, WsConnection.OPEN, WsConnection.CLOSING, WsConnection.CLOSED}
     */
    function isReady() {
        return WsConnection.readyState;
    }

    /**
     * This functions sends a message in the current channel.
     * @param message
     */
    function sendMessage(message) {
        ChatModule.sendMessageToChannel(ChatModule.getCurrentChannel(), message);
    }

    /**
     * =====================================================
     * JWT Tools Module
     * =====================================================
     */
    var JWTModule = (function () {

        /**
         * This function parses the JWT token's payload into a JS object.
         * @param token String
         * @returns {Object}
         */
        function parseJWT(token) {
            var base64 = token.split('.')[1];
            base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
            var payload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            return JSON.parse(payload);
        }

        return {
            parseJWT
        }
    })();


    /**
     * =====================================================
     * Chat Module
     * @type {{setCurrentProfile: setCurrentProfile, profile: Profile}}
     * =====================================================
     */
    var ChatModule = (function () {

        var currentProfile;
        var gameList = [];
        var chanList = [];
        var subscribedChans = [];

        var currentChannel;

        var currentQuickMatchLobby = null;

        /**
         * This class represents an User
         */
        class Profile {

            constructor (uid, nickname, avatar) {
                this.uid = uid;
                this.nickname = nickname;
                this.avatar = avatar;
            }

            getAvatar() {
                if (this.avatar === '' || this.avatar === null){
                    return '/img/defaultavatar.png'
                }
                return '/img/avatars/' + this.avatar;
            }

            getAvatarForced() {
                if (this.avatar === '' || this.avatar == null){
                    return '/img/defaultavatar.png';
                }
                return '/img/avatars/'+this.avatar+'?'+new Date().getTime();
            }

            /**
             * Returns the UID of the profile.
             * @returns {String}
             */
            getUID () {
                return this.uid;
            }

            /**
             * Returns the nickname of the user.
             * @returns {String}
             */
            getNickname () {
                return this.nickname;
            }

            /**
             * Returns if the current user equals the user passed in parameter.
             * @param profile
             * @returns {boolean}
             */
            compareTo(profile) {
                return JSON.stringify(this) === JSON.stringify(profile);
            }
        }

        /**
         * This class represents a Game
         */
        class Game {

            constructor (id, name, alias, slug, miniature, nbPlayerMultiLocal = 0, nbPlayerMultiOnline = 0) {
                this.id = id;
                this.name = name;
                this.alias = alias;
                this.slug = slug;
                this.miniature = miniature;
                this.nbPlayerMultiLocal = nbPlayerMultiLocal;
                this.nbPlayerMultiOnline = nbPlayerMultiOnline;
                this.isMultiOnline = (nbPlayerMultiOnline !== null && nbPlayerMultiOnline > 1);
                this.isMultiLocal = (nbPlayerMultiLocal !== null && nbPlayerMultiLocal > 1);
                this.isMulti = (this.isMultiOnline || this.isMultiLocal);
            }

            /**
             * This method runs a solo session for a Game.
             */
            runSolo() {
                SessionRunnerModule.init('solo', this.alias, null);
            }

            /**
             * This method is just a bridge for checking if user is already in a lobby or not.
             */
            requestMultiQuickMatch() {
                if (currentQuickMatchLobby !== null) {
                    throw new Error('This player is already in a quick match lobby.');

                    var event = new CustomEvent('gs-quick-match-error', {detail: {error: 'You are already in a quick match lobby, please quit it first.'}});
                    document.dispatchEvent(event);
                }

                //sending quick match request event
                var event = new CustomEvent('gs-quick-match-request', {detail: {game: this}});
                document.dispatchEvent(event);
            }

            /**
             * This method sends the quick match request for the current game to the server.
             * @param nbLocalPlayers number
             */
            requestMultiQuickMatchStart(nbLocalPlayers) {
                var quickMatchRequestAction = new QuickMatchRequestAction(this.slug, parseInt(nbLocalPlayers));
                wsSend(quickMatchRequestAction.sendable());
            }
        }

        /**
         * This class represents a Channel
         */
        class Channel {

            constructor (name, slug, game, profiles) {
                this.name = name;
                this.slug = slug;
                this.game = game;
                this.profiles = profiles;
            }

            /***
             * Returns channel profiles.
             * @returns {*|Array}
             */
            getProfiles() {
                return this.profiles;
            }

            /**
             * Sets the users in the channel.
             * @param profiles array
             */
            setProfiles(profiles) {
                this.profiles = profiles;
            }

            /**
             * Adds an user to the channel.
             * @param profile Profile
             */
            addProfile(profile) {
                //WORKAROUND: indexOf ou includes array functions are not working on objects arrays due to references
                let isPresent = false;
                this.profiles.forEach((u) => {
                    if (u.uid === profile.uid){
                        isPresent = true;
                    }
                });
                if (!isPresent){
                    this.profiles.push(profile);
                }
            }

            /**
             * Removes and user from the channel's user list.
             * @param profile Profile
             */
            removeProfile(profile) {
                this.profiles = this.profiles.filter(function (elem, _index) {
                    return elem.uid !== profile.uid;
                });
                for (var chan in subscribedChans) {
                    if (subscribedChans[chan] === currentChannel) {
                        subscribedChans[chan] = null;
                    }
                }
            }

            /**
             * Returns a channel user identified by its username.
             * @param uid string
             * @return Profile
             */
            getProfileByUID(uid) {
                var res;
                this.profiles.forEach(function (profile) {
                    if (profile.uid === uid) {
                        res = profile;
                        return null;
                    }
                });
                return res;
            }

            unsubscribe () {
                var unsubscribeAction = new UnsubscribeAction(this.slug);
                wsSend(unsubscribeAction.sendable());
            }

            sendMessage(message) {
                var messageChanInAction = new MessageChanInAction(this, message, getCurrentProfile());
                wsSend(messageChanInAction.sendable());
            }
        }

        /**
         * This class represents a slot in a Lobby
         */
        class LobbySlot {

            /**
             *
             * @param player Profile
             * @param ready boolean
             * @param sessionId string
             */
            constructor (player, ready, sessionId) {
                this.player = player;
                this.ready = ready;
                this.sessionId = sessionId;
            }
        }

        /**
         * This class represents a Lobby
         */
        class Lobby {

            constructor (id, name, state, game, slots, timeCreated, owner) {
                this.id = id;
                this.name = name;

                //testing if slots are already slots

                if (slots[0] instanceof LobbySlot){
                    this.slots = slots;
                } else {
                    for (var slot in slots){
                        var tempSlot = new LobbySlot();
                        this.slots.push(tempSlot);
                    }
                }

                this.timeCreated = timeCreated;
                this.owner = owner;
                this.state = state;
                this.game = game;
            }

            /**
             * This method returns the master session key of the lobby.
             * @return {*|null|string}
             */
            getMasterSessionKey() {
                for (var i in this.slots){
                    if (this.slots[i].profile.uid === this.owner.uid) {
                        return this.slots[i].sessionId;
                    }
                }
            }

            /**
             * This method asks to send a quickmatch force start message to the server
             */
            askForStart() {
                if(this.countOccupiedSlots() < 2){
                    console.error('You have to be at least 2 in a lobby to ask to start lobby')
                }
                var quickMatchOwnerForceStartRequest = new QuickMatchOwnerForceStartRequest(this.id);
                wsSend(quickMatchOwnerForceStartRequest.sendable());
            }

            /**
             * This method asks for quit the lobby.
             */
            askForQuit() {
                var quickMatchDesistAction = new QuickMatchDesistAction(this.id);
                wsSend(quickMatchDesistAction.sendable());
            }

            /**
             * This method checks if the lobby is available for cold start.
             * @returns {boolean}
             */
            checkIsQuickStartable () {
                if (this.owner.compareTo(currentProfile)) {
                    return this.countOccupiedSlots() >= 2;
                } else {
                    return false;
                }
            }

            /**
             * This method counts the number of occupied slots.
             * @returns {number}
             */
            countOccupiedSlots () {
                let res = 0;
                this.slots.forEach((slot) => {
                    if (slot.player !== null){
                        res++;
                    }
                });
                return res;
            }
        }

        /**
         * This method sets the current Chat user.
         * @param profile Profile
         */
        function setCurrentProfile(profile) {
            currentProfile = profile;
        }

        /**
         * This method returns the current Chat user.
         * @returns User
         */
        function getCurrentProfile() {
            return currentProfile;
        }

        /**
         * This method instantiates an User from an AuthResponse after authentication.
         * @param authResponse AuthResponse
         */
        function createProfileFromAuthResponse (authResponse) {
            if (!('playerInfos') in authResponse) {
                throw new Error('Response does not contains any player infos.')
            }

            return new Profile(authResponse.profile.uid,
                authResponse.profile.nickname,
                authResponse.profile.avatar);
        }

        /**
         * This method instantiates the Game list form the auth response after authentication.
         * @param authResponse
         */
        function createGameListFromAuthResponse(authResponse) {
            if (!('gameList') in authResponse) {
                throw new Error('Response does not contains any game infos.')
            }

            //clear game list
            gameList = [];

            //parsing game list
            Object.keys(authResponse.gameList).forEach(function (entry) {
                gameList.push(new Game(authResponse.gameList[entry].id, //TODO
                    authResponse.gameList[entry].name,
                    authResponse.gameList[entry].alias,
                    authResponse.gameList[entry].slug,
                    authResponse.gameList[entry].miniature,
                    authResponse.gameList[entry].nbPlayerMultiLocal,
                    authResponse.gameList[entry].nbPlayerMultiOnline));
            });

            console.debug('Parsed ' + gameList.length + ' games.');
        }

        /**
         * This method instantiates the Channel list from the auth response after authentication.
         * @param authResponse
         */
        function createChannelListFromAuthResponse(authResponse) {
            if (!('chanList') in authResponse){
                throw new Error('Response does not contains any channel infos.')
            }

            //clearing chanlist
            chanList = [];

            //parsing channel list
            authResponse.chanList.forEach(function (chan) {
                var chanGame = chan.game;
                var game = null;
                if (chanGame !== null){
                    var game = new Game(chanGame.id, chanGame.name, chanGame.alias, chanGame.slug, chanGame.miniature, chanGame.nbPlayerMultiLocal, chanGame.nbPlayerMultiOnline);
                }
                chanList.push(new Channel(chan.name, chan.slug, game, []));
            });

            console.debug('Parsed ' + chanList.length + ' channels.');
        }

        /**
         * This method updates the game list.
         * @param gameListUpdated
         */
        function setGameList(gameListUpdated) {
            //clearing current chan list
            gameList = [];

            //parsing game list
            Object.keys(gameListUpdated).forEach(function (entry) {
                gameList.push(new Game(gameListUpdated[entry].id,
                    gameListUpdated[entry].name,
                    gameListUpdated[entry].alias,
                    gameListUpdated[entry].slug,
                    gameListUpdated[entry].miniature,
                    gameListUpdated[entry].nbPlayerMultiLocal,
                    gameListUpdated[entry].nbPlayerMultiOnline));
            });

            console.debug('Updated ' + gameList.length + ' games.');
        }

        /**
         * This method updates the channel list.
         * @param channelListUpdated
         */
        function setChannelList(channelListUpdated) {
            //backing up
            var chanListBackup = chanList;

            //clearing chan list
            chanList = [];

            channelListUpdated.forEach(function (chan) {
                var chanGame = chan.game;
                var game = null;
                if (chanGame !== null){
                    game = new Game(chanGame.id, chanGame.name, chanGame.alias, chanGame.slug, chanGame.miniature, chanGame.nbPlayerMultiLocal, chanGame.nbPlayerMultiOnline);
                }

                var found = false, index = -1;
                for (var i=0; i<chanListBackup.length; i++) {
                    if (chanListBackup[i].slug === chan.slug) {
                        found = true;
                        index = i;
                        break;
                    }
                }

                if (found) {
                    chanList.push(new Channel(chan.name, chan.slug, game, chanListBackup[index].profiles));
                } else {
                    chanList.push(new Channel(chan.name, chan.slug, game, []));
                }
            });

            console.debug('Updated ' + chanList.length + ' channels.');
        }

        /**
         * This method returns the current game list.
         * @returns {Array}
         */
        function getGameList() {
            return gameList;
        }

        /**
         * This method returns the current channel list.
         * @returns {Array}
         */
        function getChannelList() {
            return chanList;
        }

        /**
         * This method sets the user's channel.
         * @param channel Channel
         */
        function setCurrentChannel(channel) {
            if (chanList.indexOf(channel) === -1){
                throw new Error('This channel does not exist.');
            }
            currentChannel = channel;

            //sending the channel change event with the new channel
            var event = new CustomEvent('gs-channel-change', {detail: {channel}});
            document.dispatchEvent(event);
        }

        /**
         * This method returns the user's channel.
         * @returns {Channel}
         */
        function getCurrentChannel() {
            return currentChannel;
        }

        /**
         * This method returns a Channel by its slug.
         * @param channelSlug string
         * @returns Channel
         */
        function getChannelBySlug(channelSlug) {
            var returnChan;
            chanList.forEach(function (channel) {
                if (channel.slug === channelSlug){
                    returnChan = channel;
                }
            });
            return returnChan;
        }

        /**
         * This factory method instantiates an User.
         * @param uid
         * @param nickname
         * @param avatar
         * @returns {Profile}
         */
        function createProfile(uid, nickname, avatar) {
            return new Profile(uid, nickname, avatar);
        }

        /**
         * This method returns a Game by its slug.
         * @param slug
         * @returns {Game}
         */
        function getGameBySlug(slug) {
            gameList.forEach(function (game) {
                if (game !== undefined && game.slug === slug){
                    return game;
                }
            });
        }

        /**
         * This method returns a Game by its ID.
         * @param id
         * @returns {Game}
         */
        function getGameByID(id) {
            gameList.forEach(function (game) {
                if (game !== undefined && game.id === id){
                    return game;
                }
            });
        }

        /**
         * This method sends a message to the server for a specific channel.
         * @param channel Channel
         * @param message string
         */
        function sendMessageToChannel(channel, message) {
            if (chanList.indexOf(channel) === -1) {
                throw new Error('This channel does not exist.');
            }

            //no more sanitization done on client side
            message = message.trim();

            var messageChanInAction = new MessageChanInAction(channel, message);
            wsSend(messageChanInAction.sendable());
        }

        /**
         * This method sends a message to the server as a bot for a specific channel.
         * @param channel
         * @param message
         */
        function sendBotMessageToChannel(channel, message) {
            if (chanList.indexOf(channel) === -1) {
                throw new Error('This channel does not exist.');
            }

            //sanitizing message
            var map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            message = message.trim();
            message = message.replace(/[&<>"']/g, function (m) {
                return map[m];
            });

            var messageChanInAction = new MessageChanInAction(channel, message, chatBot);
            wsSend(messageChanInAction.sendable());
        }

        /**
         * This method sends a quick match request to the server.
         * @param game Game
         * @param nbLocalPlayers number
         */
        function sendQuickMatchRequest(game, nbLocalPlayers = 1) {
            //checking game existence
            if (gameList.indexOf(game) === -1){
                throw new Error('This game does not exist.');
            }

            //senging quick match request
            var quickMatchRequestAction = new QuickMatchRequestAction(game.getGameBySlug, nbLocalPlayers);
            wsSend(quickMatchRequestAction.sendable());
        }

        /**
         * This method sends a subscribe request for a channel to the server.
         * @param channel Channel
         */
        function subscribeToChannel(channel) {
            if (chanList.indexOf(channel) === -1){
                throw new Error('This channel does not exist.');
            }

            //sending subscription request
            var subscribeAction = new SubscribeAction(channel.slug);
            wsSend(subscribeAction.sendable());
        }

        /**
         *
         * @param channel
         */
        function changeChannel(channel) {
            if (chanList.includes(channel)){
                if (subscribedChans.includes(channel)){
                    console.log('Setting current channel: ' + channel.name);

                    setCurrentChannel(channel);

                    //sending channel change event
                    var event = new CustomEvent('gs-channel-change', {detail: {
                        channel: getCurrentChannel()
                    }});
                    document.dispatchEvent(event);
                } else {
                    console.log('Subscribing to: ' + channel.name);

                    subscribeToChannel(channel);
                }
            } else {
                throw new Error('This channel does not exist.');
            }
        }

        /**
         * Returns the current quick match lobby.
         * @returns {Lobby}
         */
        function getCurrentQuickMatchLobby() {
            return currentQuickMatchLobby;
        }

        /**
         * Sets the current quick match lobby
         * @param lobby Lobby
         */
        function setCurrentQuickMatchLobby(lobby) {
            currentQuickMatchLobby = lobby;
        }

        /**
         * This factory method take a raw lobby object and returns a real Lobby.
         * @param lobbyRaw
         * @returns {Lobby}
         */
        function createLobby(lobbyRaw) {
            var owner = new Profile(lobbyRaw.owner.uid, lobbyRaw.owner.nickname, lobbyRaw.owner.avatar);
            var lobbyGame = new Game(lobbyRaw.game.id, lobbyRaw.game.name, lobbyRaw.game.alias, lobbyRaw.game.slug, lobbyRaw.game.miniature, lobbyRaw.game.nbPlayerMultiLocal, lobbyRaw.game.nbPlayerMultiOnline);
            var lobbySlots = [];

            for (var i in lobbyRaw.slots){
                if (lobbyRaw.slots[i].profile !== null){
                    var player = new Profile(lobbyRaw.slots[i].profile.uid, lobbyRaw.slots[i].profile.nickname, lobbyRaw.slots[i].profile.avatar);
                    lobbySlots.push(new LobbySlot(player, lobbyRaw.slots[i].ready, lobbyRaw.slots[i].sessionId));
                } else {
                    lobbySlots.push(new LobbySlot(null, false, null));
                }
            }

            return new Lobby(lobbyRaw.id, lobbyRaw.name, lobbyRaw.state, lobbyGame, lobbySlots, lobbyRaw.timeCreated, owner);
        }

        return {
            createProfileFromAuthResponse,
            setCurrentProfile,
            getCurrentProfile,
            createProfile,

            createGameListFromAuthResponse,
            getGameList,
            getGameBySlug,
            getGameByID,

            createChannelListFromAuthResponse,
            getChannelList,
            getChannelBySlug,
            setCurrentChannel,
            getCurrentChannel,
            sendMessageToChannel,
            sendBotMessageToChannel,
            subscribeToChannel,
            changeChannel,
            subscribedChannels: subscribedChans,

            createLobby,
            sendQuickMatchRequest,
            getCurrentQuickMatchLobby,
            setCurrentQuickMatchLobby
        }
    })();

    /**
     * =====================================================
     * Game Sessions Runner Module
     * =====================================================
     */
    var SessionRunnerModule = (function () {

        var strippedLobby = [];
        var url = configGlobal.backendURL + '/api/front/';
        var alias = null;
        var sessionTracker;
        var sessionTrackerSSL = false;

        /**
         *
         * @param gameMode
         * @param gameAlias
         * @param chatLobby
         */
        function init(gameMode, gameAlias, chatLobby) {

            //redefining clean URL
            url = configGlobal.backendURL + '/api/front/';

            //compute lobby structure
            if (gameMode === 'quickmatchowner'){
                for (var slot in chatLobby.slots){
                    if (chatLobby.slots[slot].profile !== null){
                        strippedLobby[slot] = chatLobby.slots[slot].profile.uid;
                    }
                }
            }

            (gameMode === 'quickmatchguest') ? url += 'join_session_multi' : url += 'session_start';

            (gameMode === 'solo') ? alias = gameAlias : alias = chatLobby.game.alias;

            var datas = {
                alias: alias,
                language: 'en',
                gamepad: true,
                profile: ChatModule.getCurrentProfile().uid,
                platform: (configGlobal.inDiv) ? 'js' : null
            };

            if (gameMode === 'quickmatchowner'){
                datas['multiplayer-mode'] = 'quickmatch';
                datas['lobby-structure'] = JSON.stringify(strippedLobby);
            } else if (gameMode === 'quickmatchguest') {
                datas['multiplayer-mode'] = 'quickmatch';
                datas['masterSessionKey'] = chatLobby.masterSessionKey;
                /*for (var i in chatLobby.slots) {
                    if (chatLobby.slots[i].profile.uid === chatLobby.owner.uid) {
                        datas['masterSessionKey'] = chatLobby.slots[i].sessionId;
                    }
                }*/
            }

            console.log(datas);

            $.ajax({
                url: url,
                type: 'POST',
                data: datas,
                headers: {
                    Authorization: 'Bearer ' + identificationToken
                },
                success: function (data) {
                    console.debug('URI: ' + data.uri);

                    sessionTracker = new SGXSessionTracker({
                        server: data.ipTracker,
                        session_id: data.sessionId,
                        reconnect_attempts: 5,
                        ssl: sessionTrackerSSL
                    });

                    sessionTracker.on('debug', function (debug) {
                        console.debug('SGX Debug: ' + debug);
                    });

                    sessionTracker.on('connected', function () {
                        console.debug('SGX Connected.')
                    });

                    sessionTracker.on('connection_lost', function () {
                        console.error('SGX Connection lost with the server.')
                    });

                    sessionTracker.on('connection_failed', function (remainingAttempts) {
                        console.warn('SGX Connection failed, remaining attempts: ' + remainingAttempts);
                    });

                    sessionTracker.on('session_not_found', function () {
                        console.error('SGX Session not found. Telling the server to close the lobby.');

                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session not found.');
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session not found.');
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                        } else {
                            var event = new CustomEvent('gs-solo-error', {detail: {
                                    error: 'Session not found.'
                                }});
                            document.dispatchEvent(event);
                        }
                    });

                    sessionTracker.on('session_pending', function () {
                        console.debug('SGX Session pending...');
                    });

                    sessionTracker.on('session_started', function () {
                        console.debug('SGX Session started.');
                    });

                    sessionTracker.on('session_failed_to_start', function () {
                        console.error('SGX Session failed to start. Telling the server to close the lobby.');

                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session failed to start.');
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session failed to start.');
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                        } else {
                            var event = new CustomEvent('gs-solo-error', {detail: {
                                    error: 'Session failed to start.'
                            }});
                            document.dispatchEvent(event);
                        }
                    });

                    sessionTracker.on('session_crashed', function () {
                        console.error('SGX Session crashed. Telling the server to close the lobby.');

                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session crashed.');
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session crashed.');
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                        } else {
                            var event = new CustomEvent('gs-solo-error', {detail: {
                                    error: 'Session crashed.'
                                }});
                            document.dispatchEvent(event);
                        }
                    });

                    sessionTracker.on('session_connect_timeout', function () {
                        console.error('SGX Session connect timeout. Telling the server to close the lobby.');

                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session connect timeout.');
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session connect timeout.');
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                        } else {
                            var event = new CustomEvent('gs-solo-error', {detail: {
                                    error: 'Session connect timeout.'
                                }});
                            document.dispatchEvent(event);
                        }
                    });

                    sessionTracker.on('session_inactive_timeout', function () {
                        console.error('SGX Session inactive timeout.');
                    });

                    sessionTracker.on('session_duration_limit_reached', function () {
                        console.error('SGX Session duration limit reached.');
                    });

                    sessionTracker.on('session_reconnect_timeout', function () {
                        console.error('SGX Session reconnect timeout.');
                    });

                    sessionTracker.on('session_connection_lost', function () {
                        console.error('SGX Session connection lost.');
                    });

                    sessionTracker.on('session_terminated', function () {
                        console.debug('SGX Session terminated. Telling the server to close the lobby.');

                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session terminated.');
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session terminated.');
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                        }
                    });

                    sessionTracker.on('session_response', function (response) {
                        switch (response.state) {
                            case SGXSessionTracker.States.SessionNotFound:
                                console.error('SGX Session not found. Telling the server to close the lobby.');

                                if (gameMode === 'quickmatchowner') {
                                    //sending message to the server
                                    var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session not found.');
                                    wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session not found.');
                                    wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                                }

                                break;

                            case SGXSessionTracker.States.SessionPending:
                                console.debug('SGX Session pending...');
                                break;

                            case SGXSessionTracker.States.SessionStarted:

                                if (configGlobal.inDiv === true) {
                                    //getting SGX config
                                    $.ajax({
                                        url: configGlobal.backendURL + '/api/cgx/sgx_files/' + data.sessionId + '.sgx',
                                        type: 'GET',
                                        success: (res) => {
                                            console.debug('Running inDiv CGX');
                                            var event = new CustomEvent('gs-run-cgx', {detail: {
                                                config: res
                                            }});
                                            document.dispatchEvent(event);
                                        },
                                        error: (err) => {
                                            console.error(err);
                                        }
                                    },);
                                } else {
                                    if (typeof cgx !== 'undefined') {
                                        cgx.Start(data.uri);
                                        console.debug('Running CGX');
                                    } else {
                                        window.location.href = data.uri;
                                        console.debug('Opening URI');
                                    }
                                }

                                if (gameMode === 'quickmatchowner') {
                                    var quickMatchOwnerStartRequestAckAction = new QuickMatchOwnerStartRequestAckAction(chatLobby.id, this.options.session_id);
                                    wsSend(quickMatchOwnerStartRequestAckAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestJoinRequestAckAction = new QuickMatchGuestsJoinRequestAckAction(chatLobby.id, this.options.session_id);
                                    wsSend(quickMatchGuestJoinRequestAckAction.sendable());
                                }
                                break;

                            case SGXSessionTracker.States.SessionFailedToStart:
                                console.error('SGX Session failed to start. Telling the server to close the lobby.');

                                if (gameMode === 'quickmatchowner') {
                                    //sending message to the server
                                    var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session failed to start.');
                                    wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session failed to start.');
                                    wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                                } else {
                                    var event = new CustomEvent('gs-solo-error', {detail: {
                                            error: 'Session failed to start.'
                                        }});
                                    document.dispatchEvent(event);
                                }

                                break;

                            case SGXSessionTracker.States.SessionCrashed:
                                console.error('SGX Session crashed. Telling the server to close the lobby.');

                                if (gameMode === 'quickmatchowner') {
                                    //sending message to the server
                                    var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session crashed.');
                                    wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session crashed.');
                                    wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                                } else {
                                    var event = new CustomEvent('gs-solo-error', {detail: {
                                            error: 'Session crashed.'
                                        }});
                                    document.dispatchEvent(event);
                                }

                                break;

                            case SGXSessionTracker.States.SessionConnectTimeout:
                                console.error('SGX Session connect timeout. Telling the server to close the lobby.');

                                if (gameMode === 'quickmatchowner') {
                                    //sending message to the server
                                    var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session connect timeout');
                                    wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session connect timeout..');
                                    wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                                } else {
                                    var event = new CustomEvent('gs-solo-error', {detail: {
                                            error: 'Session connect timeout.'
                                        }});
                                    document.dispatchEvent(event);
                                }

                                break;

                            case SGXSessionTracker.States.SessionInactiveTimeout:
                                console.error('SGX Session inactive timeout.');
                                break;

                            case SGXSessionTracker.States.SessionDurationLimitReached:
                                console.error('SGX Session duration limit reached.');
                                break;

                            case SGXSessionTracker.States.SessionReconnectTimeout:
                                console.error('SGX Session reconnect timeout.');
                                break;

                            case SGXSessionTracker.States.SessionTerminated:
                                console.debug('SGX Session terminated. Telling the server to close the lobby.');

                                if (gameMode === 'quickmatchowner') {
                                    //sending message to the server
                                    var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, 'Session terminated.');
                                    wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                                } else if (gameMode === 'quickmatchguest') {
                                    var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'Session terminated.');
                                    wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
                                }

                                break;

                            case SGXSessionTracker.States.SessionConnectionLost:
                                console.error('SGX Session connection lost.');
                                break;
                        }

                        console.debug('Response: ' + JSON.stringify(response));
                    });

                    console.debug('Running session tracker.');
                    sessionTracker.run();

                }.bind(this),
                error: function (err) {
                    if (chatLobby !== null){
                        if (gameMode === 'quickmatchowner') {
                            //sending message to the server
                            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(chatLobby.id, err.responseJSON.message);
                            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
                        } else if (gameMode === 'quickmatchguest') {
                            if (err.responseJSON === undefined || err.responseJSON === null) {
                                var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, 'An error occurred');

                            } else {
                                var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(chatLobby.id, err.responseJSON.message);
                            }
                            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());

                            var event = new CustomEvent('gs-multiplayer-error', {detail: {error: err.responseJSON ? err.responseJSON.message : 'An error occurred'}});
                            document.dispatchEvent(event);
                        }
                    } else {
                        var event = new CustomEvent('gs-error', {detail: {error: err.responseJSON.message}});
                        document.dispatchEvent(event);
                    }
                }
            });
        }

        /**
         * Sends the quick match owner start request error to the server, useful when preventSGXSessionStart is set to true.
         * @param lobbyId
         * @param reason
         */
        function sendStartRequestError(lobbyId, reason) {
            //sending message to the server
            var quickMatchOwnerStartRequestErrorAction = new QuickMatchOwnerStartRequestErrorAction(lobbyId, reason);
            wsSend(quickMatchOwnerStartRequestErrorAction.sendable());
        }

        /**
         * Sends the quick match guests join request error to the server, useful when preventSGXSessionStart is set to true.
         * @param lobbyId
         * @param reason
         */
        function sendGuestsJoinRequestError(lobbyId, reason) {
            //sending message to the server
            var quickMatchGuestsJoinRequestErrorAction = new QuickMatchGuestsJoinRequestErrorAction(lobbyId, reason);
            wsSend(quickMatchGuestsJoinRequestErrorAction.sendable());
        }

        /**
         * Sends the quick match owner start request ACK to the server, useful when preventSGXSesionStart is set to true.
         * @param lobbyId
         * @param sessionId
         */
        function sendQuickMatchOwnerStartRequestAck(lobbyId, sessionId) {
            var quickMatchOwnerStartRequestAckAction = new QuickMatchOwnerStartRequestAckAction(lobbyId, sessionId);
            wsSend(quickMatchOwnerStartRequestAckAction.sendable());
        }

        /**
         * Sends the quick match guest join request ACK to the server, useful when preventSGXSessionStart is set to true.
         * @param lobbyId
         * @param sessionId
         */
        function sendQuickMatchGuestJoinRequestAck(lobbyId, sessionId) {
            var quickMatchGuestsJoinRequestAckAction = new QuickMatchGuestsJoinRequestAckAction(lobbyId, sessionId);
            wsSend(quickMatchGuestsJoinRequestAckAction.sendable());
        }

        return {
            init,
            sendStartRequestError,
            sendGuestsJoinRequestError,
            sendQuickMatchOwnerStartRequestAck,
            sendQuickMatchGuestJoinRequestAck
        }
    })();

    return {
        boot: boot,
        close: close,
        isReady: isReady,
        onError: wsOnError,
        sendMessage: sendMessage,
        chat: ChatModule,
        sessionRunner: SessionRunnerModule,
        changeChannel: ChatModule.changeChannel,
        jwtModule: JWTModule
    }
})();

export {gsChatModule};